<template>
  <form name="permissions-info-model-form" @submit.prevent="$emit('save')">
    <BLayoutExpansion title="Основное" class="my-4">
      <v-row dense>
        <v-col cols="12" sm="3">
          <BAutocompleteCommon
            :value="form.info_model && form.info_model.application"
            $type="permission-application"
            disabled
            :skeleton="skeleton"
            name="application"
          />
        </v-col>

        <v-col cols="12" sm="3">
          <v-row dense align="center">
            <v-col>
              <BAutocompleteCommon
                ref="info_model"
                v-model="form.info_model"
                validate="required"
                $type="permission-info-model"
                :disabled="isView"
                :skeleton="skeleton"
                name="info_model"
              />
            </v-col>
            <v-col cols="auto">
              <BTooltipButton
                :to="infoModelRoute"
                target="_blank"
                tooltip="Добавить Инфо модель"
                icon="mdi-plus"
                tile
                top
                @click="$refs.info_model.reset()"
              />
            </v-col>
          </v-row>
        </v-col>

        <v-col cols="12" sm="3">
          <v-row dense align="center">
            <v-col>
              <BAutocompleteCommon
                ref="type"
                v-model="form.permission_type"
                validate="required"
                $type="permission-type"
                :disabled="isView"
                :skeleton="skeleton"
                name="permission_type"
              />
            </v-col>
            <v-col cols="auto">
              <BTooltipButton
                :to="typeRoute"
                target="_blank"
                tooltip="Добавить Действие"
                icon="mdi-plus"
                tile
                top
                @click="$refs.type.reset()"
              />
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-row dense>
        <v-col sm="9">
          <BTextField
            :value="code"
            validate="required"
            label="Код"
            disabled
            :skeleton="skeleton"
            name="code"
            autofocus
          />
        </v-col>

        <!--
        <v-col sm="6" lg="5">
          <BTextField
            v-model="form.name"
            validate="required"
            label="Название"
            disabled
            :skeleton="skeleton"
            name="name"
          />
        </v-col>
        -->
      </v-row>

      <v-row v-if="!isCreate" dense>
        <v-col :cols="!skeleton && 'auto'">
          <BTextField
            :value="data.created_at | dateFormatter"
            :skeleton="skeleton"
            label="Создан"
            disabled
          />
        </v-col>

        <v-col :cols="!skeleton && 'auto'">
          <BTextField
            :value="data.updated_at | dateFormatter"
            :skeleton="skeleton"
            label="Обновлен"
            disabled
          />
        </v-col>
      </v-row>
    </BLayoutExpansion>

    <button type="submit" class="d-none" />
  </form>
</template>

<script>
import { PERMISSIONS_INFOMODELS_ROUTES } from '@/views/Permissions/InfoModels/utils'
import { PERMISSIONS_PERMISSION_TYPES_ROUTES } from '@/views/Permissions/PermissionTypes/utils'

import BLayoutForm from '@/components/layouts/BLayoutForm.vue'
import BLayoutExpansion from '@/components/layouts/BLayoutExpansion.vue'
import BTooltipButton from '@/components/common/BTooltipButton.vue'
import BTextField from '@/components/forms/BTextField.vue'
import BAutocompleteCommon from '@/components/forms/BAutocompleteCommon.vue'


const createDefaultData = () => ({
  // id
  code: '',
  info_model: null,
  permission_type: null,
  name: '',
  // created_at
  // updated_at
})

export default {
  name: 'PermissionsPermissionsForm',
  components: {
    BLayoutExpansion,
    BTooltipButton,
    BTextField,
    BAutocompleteCommon,
  },
  extends: BLayoutForm,
  props: {
    skeleton: Boolean,
    data: {
      type: Object,
      required: true,
      default: createDefaultData,
    },
  },
  data: () => ({
    infoModelRoute: {
      name: PERMISSIONS_INFOMODELS_ROUTES.CREATE,
    },
    typeRoute: {
      name: PERMISSIONS_PERMISSION_TYPES_ROUTES.CREATE,
    },
  }),
  computed: {
    code() {
      return [
        this.form.info_model?.application?.code || '<APPLICATION>',
        this.form.info_model?.code || '<INFO_MODEL>',
        this.form.permission_type?.code || '<PERMISSION_TYPE>',
      ].join(' / ')
    },
  },
  methods: {
    async onSubmit() {
      const result = await this.$validator.validate()

      if (!result) {
        this.$notice.validatorFormError(this)
        const message = `Error submit: ${this.$options.name}`
        const error = new Error(message)
        return Promise.reject(error)
      }

      const { form } = this

      const data = {
        ...form,

        info_model: void 0,
        info_model_id: form.info_model?.id ?? null,

        permission_type: void 0,
        permission_type_id: form.permission_type?.id ?? null,
      }

      this.$emit('submit', data)

      return data
    },
  },
}
</script>
